import React from 'react';
import { Checkbox, Text } from '@homeexchange/design';
import i18n from '../../../../i18n';
import styles from './favorite.module.scss';
export var Favorites = function (_a) {
    var checked = _a.checked, onChange = _a.onChange;
    var handleInputChange = function (event) {
        onChange(event.target.value, event.target.checked);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { className: styles['favorite-text'] }, i18n.t('search:filter.favorites-tips')),
        React.createElement(Checkbox, { label: i18n.t('search:filter.favorites-show'), value: "favorite", checked: checked, onChange: handleInputChange })));
};
